module.exports = __webpack_public_path__ + "img/ganghaolai-mall-home.a8df5884.jpg";